export default __webpack_public_path__ + "static/media/arcanecrystals2.68b0e53c.png";